import { defineStore } from 'pinia';
import { ref } from 'vue';
import { purchaseOrdersApi } from '@/services/purchaseOrdersApi';

/**
 * Contagem de pedidos de compra aguardando a decisão do usuário (badge do menu
 * "Pedidos de Compra"). Poller singleton: o NavCollapse do item chama start() ao
 * montar; refresh() pode ser disparado após uma decisão para atualizar na hora.
 */
export const usePurchaseOrderBadgeStore = defineStore('purchaseOrderBadge', () => {
  const count = ref(0);
  let timer: ReturnType<typeof setInterval> | null = null;

  async function refresh() {
    try {
      const { count: c } = await purchaseOrdersApi.newCount();
      count.value = Number(c) || 0;
    } catch {
      /* silencioso — badge é best-effort */
    }
  }

  function start(intervalMs = 60000) {
    void refresh();
    if (timer) return; // já rodando (singleton)
    timer = setInterval(refresh, intervalMs);
  }

  function stop() {
    if (timer) {
      clearInterval(timer);
      timer = null;
    }
  }

  return { count, refresh, start, stop };
});

export default usePurchaseOrderBadgeStore;
